/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_External_Directories_Link_NofollowInputs */

const en_directory_external_directories_link_nofollow = /** @type {(inputs: Directory_External_Directories_Link_NofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nofollow`)
};

const zh_directory_external_directories_link_nofollow = /** @type {(inputs: Directory_External_Directories_Link_NofollowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nofollow`)
};

/**
* | output |
* | --- |
* | "Nofollow" |
*
* @param {Directory_External_Directories_Link_NofollowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_external_directories_link_nofollow = /** @type {((inputs?: Directory_External_Directories_Link_NofollowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_External_Directories_Link_NofollowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_external_directories_link_nofollow(inputs)
	return zh_directory_external_directories_link_nofollow(inputs)
});
export { directory_external_directories_link_nofollow as "directory.external_directories.link_nofollow" }